import { Tooltip } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { LabelsIcon } from '../../../../../../../styles';
import { StyledIconButton } from './shared-styles';

interface DisplayLabelsToggleProps {
  onClick: () => void;
}

export const DisplayLabelsToggle = (props: DisplayLabelsToggleProps) => {
  const { onClick } = props;
  const { t } = useTranslation();

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    onClick();
  };

  return (
    <Tooltip
      title={t('common:commonValues.tooltips.toggleLabels')}
      placement="top"
    >
      <StyledIconButton
        onClick={handleClick}
        size="small"
        aria-label="Toggle Labels"
      >
        <LabelsIcon />
      </StyledIconButton>
    </Tooltip>
  );
};
